/**
 * @generated SignedSource<<f11b8ad85d4a8648f27047d7727764c5>>
 * @relayHash 21eb9b2f68fd07b6dd354cd71f6817a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 49b27eae598e81fd11f04504c82f6e5417286603f5a694f61e4a827274919f9b

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkSuggestionsMergePRActionInput = {
  cloudId: string;
  taskId: string;
};
export type detailsUseWorkSuggestionsMergeMutation_pullRequestMutation$variables = {
  input: WorkSuggestionsMergePRActionInput;
};
export type detailsUseWorkSuggestionsMergeMutation_pullRequestMutation$data = {
  readonly workSuggestions: {
    readonly mergePullRequest: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type detailsUseWorkSuggestionsMergeMutation_pullRequestMutation = {
  response: detailsUseWorkSuggestionsMergeMutation_pullRequestMutation$data;
  variables: detailsUseWorkSuggestionsMergeMutation_pullRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "WorkSuggestionsMutation",
    "kind": "LinkedField",
    "name": "workSuggestions",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "WorkSuggestionsMergePRActionPayload",
        "kind": "LinkedField",
        "name": "mergePullRequest",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "detailsUseWorkSuggestionsMergeMutation_pullRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "detailsUseWorkSuggestionsMergeMutation_pullRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "49b27eae598e81fd11f04504c82f6e5417286603f5a694f61e4a827274919f9b",
    "metadata": {},
    "name": "detailsUseWorkSuggestionsMergeMutation_pullRequestMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "cc7166ad5da84219489d6bf1122ba3da";

export default node;
